module.exports = __webpack_public_path__ + "img/icon_my_curve_list_white.bdf0853a.svg";